var heading_default = {
  "fontElementMap": "b5Px5",
  "elementSpacing": "CLBxX",
  "headerOne": "KrkbZ CLBxX",
  "headerTwo": "HrEPg CLBxX",
  "headerThree": "vOl-o CLBxX",
  "headerFour": "cQXH6 CLBxX",
  "headerFive": "JWFDa CLBxX",
  "headerSix": "m0lj8 CLBxX",
  "child": "ZvZMU"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
